import queryString from 'query-string';
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image) {
        return '';
    }
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        rmode: 'crop',
        upscale: true,
        ...imageParams,
    };
    const paramsString = queryString.stringify(params);
    return `${image.src}${paramsString ? `${(image.src.indexOf('?') > -1 ? '&' : '?')}${queryString.stringify(params)}` : ''}`;
}
